import { Injectable } from '@angular/core';
import * as i0 from "@angular/core";
import * as i1 from "./token.service";
export class TokenInterceptor {
    constructor(tokenService) {
        this.tokenService = tokenService;
    }
    intercept(request, next) {
        request = request.clone({
            setHeaders: {
                Authorization: `Bearer ${this.tokenService.token}`,
            },
        });
        return next.handle(request);
    }
}
TokenInterceptor.ɵfac = function TokenInterceptor_Factory(t) { return new (t || TokenInterceptor)(i0.ɵɵinject(i1.TokenService)); };
TokenInterceptor.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: TokenInterceptor, factory: TokenInterceptor.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TokenInterceptor, [{
        type: Injectable
    }], function () { return [{ type: i1.TokenService }]; }, null); })();
